<template>
  <article class="referral-guide-box__container">
    <h3 class="referral-guide-box__title">지인 초대 가이드 및 혜택 안내</h3>
    <p class="referral-guide-box__description">
      피플박스를 아직 이용해 본 적 없는 지인이 있다면 지금 바로 초대해 보세요! 
      초대받은 지인이 피플박스 신규 가입 후 유료 플랜으로 전환하면 두 분 모두 플랜 1개월씩 연장해 드립니다. 
      <a href="#" @click="openPage">
        약관 보기
      </a>
    </p>
    <ul>
      <li 
        v-for="content in guideDescriptions"
        :key="content.label"
        class="referral-guide-box__detail-description"
      >
        <div>
          <img :src="content.src">
        </div>
        <p>{{ content.description }}</p>
      </li>
    </ul>
  </article>
</template>

<script>
export default {
  data(){
    return{
      guideDescriptions:[
        { 
          label: 'email',
          src: '/image/folder/icon/mail.png',
          description: '초대 링크를 복사해서 지인에게 직접 공유하거나 지인의 이메일로 초대 이메일을 보내보세요.',
        },
        { 
          label: 'request-question',
          src: '/image/folder/icon/happy.png',
          description: '초대받은 지인이 원활하게 피플박스를 가입하고 이용할 수 있도록 안내해 주세요. 지원이 필요하시다면 언제든지 FIFL 운영팀에 1:1 상담으로 말씀해 주세요. 최선을 다해 도움드리겠습니다.',
        },
        { 
          label: 'plan-extionsion',
          src: '/image/folder/icon/discount.png',
          description: '초대 링크를 통해 가입한 지인이 유료 플랜으로 전환하는 즉시 두 분 모두에게 플랜 1개월 무료 연장 혜택이 제공됩니다.',
        },
      ]   
    };
  },
  methods:{
    openPage(){
      window.open('https://bit.ly/3ngB071','_blank');
    },
  },
};
</script>

<style lang="scss">
    .referral-guide-box__container{
        width: 100%;
        height: 100%;
        background-color: #ffffff;
        border-radius: 6px;
        padding: 20px;
        .referral-guide-box__title{
            font-size: 14px;
            font-weight: 500;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.43;
            letter-spacing: -0.8px;
            color: #4a4a4a;
            margin-bottom: 5px;
        }
        .referral-guide-box__description{
            font-size: 12px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.5;
            letter-spacing: -0.8px;
            color: #4a4a4a;
            margin-bottom: 26px;
            a{
                text-decoration: underline;
            }
        }
        .referral-guide-box__detail-description{
            display: flex;
            &:not(:last-child){
                margin-bottom: 15px;
            }
            div{
                width: 70px;
                margin-right: 13px;
                display: flex;
                img{
                  width: 30px;
                  height: 30px;
                  margin: auto;
                }
            }
            p{  
                width: calc(100% - 70px - 13px);
                font-size: 12px;
                font-weight: normal;
                font-stretch: normal;
                font-style: normal;
                line-height: 1.5;
                letter-spacing: -0.85px;
                color: #9b9b9b;
                margin: 0;
            }
        }
    }
</style>